import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import CustomViewButton from "../../../CustomComponent/custom_view_button";

const tableHead = [
  "Sr.",
  "feature",
  "Route",
  "access-Roles",
  "develope By",
  "status",
  "Actions",
];
const getDevelopeBy = (item) => {
  if (item.developBy && item.backendBy && item.developBy !== item.backendBy) {
    return `Develop by ${item?.developBy} and backend by ${item?.backendBy}`;
  }
  if (item.developBy && item.backendBy && item.developBy == item.backendBy) {
    return `Develop and backend by ${item?.developBy}`;
  }
  if (item.developBy && !item.backendBy) {
    return `Develop by ${item?.developBy}`;
  }
  if (item.backendBy && !item.developBy) {
    return `Backend by ${item?.backendBy}`;
  } else {
    return "N/A";
  }
};
const getBadgeForStatus = (status) => {
  if (status === "inprocess") {
    return (
      <span className="text-white badge bg-red">{status.toUpperCase()}</span>
    );
  }

  if (status === "testing") {
    return (
      <span className="text-white badge bg-orange">{status.toUpperCase()}</span>
    );
  }
  if (status === "deployed") {
    return (
      <span className="text-white badge bg-yellow">{status.toUpperCase()}</span>
    );
  }
  if (status === "under review") {
    return (
      <span className="text-white badge bg-lime">{status.toUpperCase()}</span>
    );
  }
  if (status === "completed") {
    return (
      <span className="text-white badge bg-green">{status.toUpperCase()}</span>
    );
  }
  return (
    <span className="text-white badge bg-cyan">{status.toUpperCase()}</span>
  );
};
const AllFeaturesTable = ({ Features = [], currentPage, itemsPerPage }) => {
  const navigate = useNavigate();
  const goToView = (id) => {
    navigate(`/feature-docs/view/${id}`);
  };
  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return <th key={index}>{item}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {Features?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.id}>
                <td>{Index}</td>
                <td>{item?.feature || "N/A"}</td>
                <td>
                  {item?.accessRoute ? (
                    <NavLink to={item?.accessRoute}>
                      {item?.accessRoute.toUpperCase()}
                    </NavLink>
                  ) : (
                    "N/A"
                  )}
                </td>
                <td>
                  {(item?.accessRoles?.join(", ") || "N/A").toUpperCase()}
                </td>
                <td>{getDevelopeBy(item)}</td>

                <td>{getBadgeForStatus(item?.status)}</td>
                <td>
                  <CustomViewButton
                    onClick={() => goToView(item.id)}
                  ></CustomViewButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
export default AllFeaturesTable;
